import {
  GET_MENU,
  GET_MENU_FAIL,
  GET_MENU_RESET,
  GET_MENU_SUCCESS,
} from "./actionTypes";

export const getMenu = () => {
  return {
    type: GET_MENU,
    payload: {},
  };
};

export const getMenuSuccess = menu => {
  return {
    type: GET_MENU_SUCCESS,
    payload: menu.data,
  };
};

export const getMenuFail = error => ({
  type: GET_MENU_FAIL,
  payload: error,
});

export const resetGetMenu = () => ({
  type: GET_MENU_RESET,
  payload: {},
});
